module.exports = __webpack_public_path__ + "img/10.d8bc87ad.gif";